<template>
  <span>
                  <a @click="toggleTag(tag, tagIndex)"
                     class="circle mr-2 pointer"
                     :style="`background-color: ${tag.color}`"
                     v-for="(tag, tagIndex) in patient.tags"
                     :title="tag.title"
                     v-b-tooltip.hover
                     :key="`made-tag-${tagIndex}`"></a>
              </span>
</template>

<script setup>
defineProps({
  patient: {
    type: Object,
  },
  editable: {
    type: Boolean,
    default: false,
  }
})

const emit = defineEmits(['toggleTag'])

const toggleTag = (tag, tagIndex) => {
  emit('toggleTag', tag, 'remove', tagIndex)
}
</script>
